module.exports = __webpack_public_path__ + "img/delete-site2.aff94f3c.svg";